import React from 'react';
import {
  IUserPermissionFieldsFragment,
  UserState,
} from '../../../../utils/apollo/graphqlSchema';
import Avatar from '../../../../components/Avatar';
import styled from 'styled-components';
import TimezonePopup from '../../../../components/TimezonePopup';
import { globalFormat } from '../../../../utils/formatting';
import { theme } from '../../../../styles/theme';

interface IProps {
  user: IUserPermissionFieldsFragment;
  isEditing: boolean;
}

const ProfileContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  justify-content: center;
`;

const UserContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
`;

const UserTitle = styled.div`
  display: flex;
  column-gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
  > span {
    font-weight: 500;
    color: ${theme.colors.secondary800};
  }
`;

const SubText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
  display: flex;
  column-gap: 4px;
`;

/**
 * UserProfileCard is the component for displaying user profile in Permission - User page.
 */
const UserProfileCard = ({ user, isEditing }: IProps) => {
  const { dateFormat, timeFormat } = globalFormat.getGlobalFormat();

  return (
    <ProfileContainer>
      <UserContainer>
        <Avatar picture={user.picture} size={90} />
        <ColumnContainer>
          <UserTitle>
            {user.name}
            {user.state !== UserState.Active && <span>[Disabled]</span>}
            {isEditing && <span>[Unsaved]</span>}
          </UserTitle>
          <SubText>{user.email}</SubText>
        </ColumnContainer>
      </UserContainer>
      <ColumnContainer>
        <SubText>
          Last Login:
          <TimezonePopup
            timestamp={user.lastLogin}
            showTimezone
            dateFormat={dateFormat}
            timeFormat={timeFormat}
            placement="bottom-start"
          />
        </SubText>
        <SubText>
          Joined On:
          <TimezonePopup
            timestamp={user.createdAt}
            showTimezone
            dateFormat={dateFormat}
            timeFormat={timeFormat}
            placement="bottom-start"
          />
        </SubText>
      </ColumnContainer>
    </ProfileContainer>
  );
};

export default UserProfileCard;
